const DOCUMENT_TYPE_LABELS = {
    pacra_certificate: 'PACRA Certificate',
    tax_clearance: 'Tax Clearance Certificate',
    other_licence: 'Other Business Licence',
};

export const documentTypeLabel = (value) => {
    if (!value) return '—';
    const key = String(value).toLowerCase();
    if (DOCUMENT_TYPE_LABELS[key]) {
        return DOCUMENT_TYPE_LABELS[key];
    }
    return String(value)
        .split('_')
        .map((part) => (part ? part[0].toUpperCase() + part.slice(1) : part))
        .join(' ');
};
